import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './ui/SectionHeading';
import { faqs } from '../data/landing';
export function Faq() {
  const [abierta, setAbierta] = useState<number | null>(0);
  return <section className="w-full bg-arena py-12 sm:py-20" aria-labelledby="faq-titulo" data-id="element-41" data-mp="1geiki8ubgix4">
      <div className="mx-auto max-w-2xl px-5 sm:px-8" data-id="element-42" data-mp="2dzxtw90xqfjq">
        <Reveal data-id="element-43" data-mp="290tlhklu4lug">
          <SectionHeading eyebrow="Dudas frecuentes" title={<span id="faq-titulo" data-id="element-45" data-mp="28za7y1rkcowd">Preguntas frecuentes</span>} data-id="element-44" data-mp="29139j2nbkixi" />
        </Reveal>

        <ul className="mt-10 space-y-3" data-id="element-46" data-mp="240fbhx0ob1ts">
          {faqs.map((faq, index) => {
          const activa = abierta === index;
          return <Reveal key={faq.pregunta} delay={0.03 * index} data-id="element-47" data-mp="sn3f2778tlhn" data-mpi={index}>
                <li className="overflow-hidden rounded-3xl border border-rosa-100 bg-white" data-id="element-48" data-mp="soo9lwtk54fi">
                  <h3 data-id="element-49" data-mp="nmgsytxs906u">
                    <button type="button" onClick={() => setAbierta(activa ? null : index)} aria-expanded={activa} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition hover:bg-rosa-50 sm:px-7 sm:py-5" data-id="element-50" data-mp="nq4ofymsfwo7">
                      <span className="font-sans text-base font-bold leading-snug text-borgona sm:text-xl" data-id="element-51" data-mp="fj8h3klb05ah">
                        {faq.pregunta}
                      </span>
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-rosa-50 text-frambuesa" data-id="element-52" data-mp="6qezhgidwttg">
                        {activa ? <MinusIcon className="h-5 w-5" aria-hidden="true" data-id="element-53" data-mp="bk9iehq614rh" /> : <PlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-54" data-mp="3szfzezqn7uh4" />}
                      </span>
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-55" data-mp="1q0opqpef5rq">
                    {activa && <motion.div id={`faq-panel-${index}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.28,
                  ease: [0.22, 1, 0.36, 1]
                }} className="overflow-hidden" data-id="element-56" data-mp="3jz9ptoy2fen8">
                        <p className="px-5 pb-5 font-sans text-base leading-relaxed text-suave sm:px-7 sm:text-lg" data-id="element-57" data-mp="1fsgjtlf1ena0">
                          {faq.respuesta}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </li>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}